import { render, staticRenderFns } from "./SkeletonComparisonHeader.vue?vue&type=template&id=3c1f8e1a&"
import script from "./SkeletonComparisonHeader.vue?vue&type=script&lang=js&"
export * from "./SkeletonComparisonHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports